var React = require('react');

function IconPaper (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M24.333 5.667v12h-6.666v6.667h-12V5.667h18.666m0-2.667H5.667A2.675 2.675 0 0 0 3 5.667v18.666A2.675 2.675 0 0 0 5.667 27H19l8-8V5.667A2.675 2.675 0 0 0 24.333 3zM15 17.667H8.333V15H15zm6.667-5.333H8.333V9.667h13.334z","transform":"translate(-3 -3)"}));
}

IconPaper.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconPaper;

IconPaper.default = IconPaper;
